import { AppSettings } from "appSettings/appSettings.dev";
import { Person, SurveyPerson, PersonXLS, File, FileDetail } from "../types";
import { BaseService } from "./BaseService";

class PersonService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async getPersonsByCompany(params: any): Promise<Person[]> {
    const { codeUp, filter, active, vinculationType } = params;
    const response = await this.baseService.get<Person[]>(
      `Person/GetPersonsByCompany?codeUp=${codeUp}&filter=${filter || "ALL"}&active=${
        active || "true"
      }&vinculationType=${vinculationType || "ALL"}`
    );
    return response?.data ?? [];
  }

  async getPersonId(id: number): Promise<Person> {
    const response = await this.baseService.get<Person>(`Person/GetPersonId?id=${id}`);
    return response?.data ?? [];
  }

  async getPerson({ identificationNumber, personId }: any): Promise<SurveyPerson> {
    let complement = "";
    if (personId && identificationNumber) {
      complement = `identificationNumber=${identificationNumber}&personID=${personId}`;
    } else if (personId || identificationNumber) {
      complement = personId ? `personID=${personId}` : `identificationNumber=${identificationNumber}`;
    }
    const response = await this.baseService.get<SurveyPerson>(`Person/GetPerson?${complement}`);
    return response?.data ?? [];
  }

  async getSumaryExcelFilesLog(codeUp: string): Promise<File[]> {
    const response = await this.baseService.get<File[]>(`Person/GetSummaryExcelFilesLog?codeUp=${codeUp}`);
    return response?.data ?? [];
  }

  async getDetailsExcelFilesLog(codeUp: string, excelFileName: string): Promise<FileDetail[]> {
    const response = await this.baseService.get<FileDetail[]>(
      `Person/GetDetailsExcelFilesLog?codeUp=${codeUp}&excelFileName=${excelFileName}`
    );
    return response?.data ?? {};
  }

  async savePerson(person: SurveyPerson): Promise<any> {
    const response = await this.baseService.post<SurveyPerson, any>("Person/savePerson", person);
    return response?.data;
  }

  async savePersonXLS(person: PersonXLS[], userCreation: string, fileName: string): Promise<any> {
    const response = await this.baseService.post<PersonXLS[], any>(
      `Person/SavePersonXLS?userCreation=${userCreation}&excelFileName=${fileName}`,
      person
    );
    return response?.data;
  }
}

export const personService = new PersonService();
